export default {
  host_biz: 'http://fm-dev.lsevp-api.winm2m.com'
}



// WEBPACK FOOTER //
// ./src/api/config.js